// What a person's role in the business is called on screen. One place, so the team settings list
// and the sidebar's user card (decision 60) cannot name the same role two ways. Block 234 found
// the old three-case version calling owners, managers and backup owners "Member".
// 'member' and 'user' are the same thing spelled two ways in the store.
export function roleLabel(role) {
  switch (role) {
    case 'super_admin':   return 'Admin';
    case 'owner':         return 'Owner';
    case 'backup_owner':  return 'Backup owner';
    case 'admin':         return 'Admin';
    case 'finance':       return 'Finance';
    case 'manager':       return 'Manager';
    default:              return 'Member';     // 'member' and 'user'
  }
}

// The role line on the sidebar's user card (decision 60). In a business they own (the workspace list
// marks the ones they only work in with isTeam or isMember) it is Owner; elsewhere their membership
// role; in Personal nothing. Platform admin is a separate tag, never this line.
export function userCardRole({ workspace, teamRole, isPersonal }) {
  if (isPersonal || !workspace) return '';
  const owns = !workspace.isTeam && !workspace.isMember;
  return roleLabel(owns ? 'owner' : (teamRole || 'member'));
}
